// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fd-1","productName":"Table_productName__3ApBs"};